// Mock data for Pride Path Commercial clone

export const companyInfo = {
  name: "Pride Path Commercial (pvt) ltd",
  tagline: "Empowering You to Reach Greater Heights",
  slogan: "The Trusted Leader",
  phone: "+94 55 313 0227",
  email: "pridepathlk@gmail.com",
  fax: "+94 112 631 190",
  address: "11 Mile Post, Monaragala Road, Buttala"
};

export const navLinks = [
  { label: "HOME", path: "/" },
  { label: "ABOUT", path: "/about" },
  {
    label: "OUR PRODUCTS",
    path: "/products",
    submenu: [
      { label: "Leasing & Loans", path: "/products/leasing-loans" },
      { label: "Margin Trading", path: "/products/margin-trading" },
      { label: "Gold Loan", path: "/products/gold-cash" },
      { label: "PLC Online", path: "/products/plc-online" },
      { label: "Islamic Finance", path: "/products/islamic-finance" },
      { label: "Financial Literacy Information", path: "/products/financial-literacy" },
      { label: "Key Facts Document", path: "/products/key-facts" },
      { label: "Others", path: "/products/others" }
    ]
  },
  { label: "NEWS & EVENTS", path: "/news" },
  { label: "BRANCHES", path: "/branches" }
];

export const topNavLinks = [
  { label: "Sustainability", path: "/sustainability" },
  { label: "Our Reach", path: "/our-reach" }
];

export const aboutDropdown = [
  { label: "Profile", path: "/about/profile" },
  { label: "Overview", path: "/about/overview" },
  { label: "History", path: "/about/history" },
  { label: "Board of Directors", path: "/about/board-of-directors" },
  { label: "Careers", path: "/about/careers" }
];

export const expertiseItems = [
  {
    id: 1,
    icon: "Briefcase",
    title: "Leasing and Loans",
    description: "Easy leasing to own your dream vehicle and instant loans for urgent financial needs under one roof. Fast and trusted service with minimal documentation and competitive rates."
  },
  {
    id: 2,
    icon: "Percent",
    title: "Business Loan",
    description: "Competitive rates with high security.\nConvenient and convenience operation.\nInvestment plans - plan your future, today."
  },
  {
    id: 3,
    icon: "Car",
    title: "Auto Loan",
    description: "Get your dream vehicle with the hassle free and stay stress-free.\nBe a part of trusted leader"
  },
  {
    id: 4,
    icon: "Coins",
    title: "Gold Loan",
    description: "Speedy and unmatched solutions to your urgent financial needs."
  }
];

// Leasing & Loans Sub-products
export const leasingLoansProducts = [
  {
    id: 1,
    slug: "auto-loan",
    title: "Auto Loan",
    shortDescription: "Drive your dream vehicle home with our flexible auto loan solutions.",
    image: "/auto-loan-bg.png",
    heroImage: "/auto-loan-bg.png",
    icon: "Car",
    hasCalculator: true,
    features: [
      "Financing up to 70% of vehicle value",
      "Flexible repayment up to 7 years",
      "Quick approval within 24 hours",
      "No hidden charges",
      "Competitive interest rates",
      "Free vehicle valuation",
      "Insurance facilitation",
      "Online application available"
    ],
    eligibility: [
      "Sri Lankan citizens aged 18-60 years",
      "Stable income source (minimum LKR 35,000/month)",
      "Good credit history",
      "Valid driving license",
      "Minimum 1 year employment"
    ],
    documents: [
      "NIC copy (front and back)",
      "Income proof (salary slips - 3 months)",
      "Bank statements (6 months)",
      "Vehicle documents (quotation/invoice)",
      "Address proof (utility bill)",
      "Employment confirmation letter"
    ],
    interestRates: [
      { type: "Brand New Vehicles", rate: "14% - 16% p.a.", maxTenure: "7 years" },
      { type: "Used Vehicles (< 3 years)", rate: "15% - 17% p.a.", maxTenure: "6 years" },
      { type: "Used Vehicles (3-5 years)", rate: "16% - 18% p.a.", maxTenure: "5 years" },
      { type: "Used Vehicles (5-10 years)", rate: "18% - 20% p.a.", maxTenure: "4 years" }
    ],
    loanAmounts: { min: 100000, max: 50000000 },
    tenureMonths: { min: 12, max: 84 }
  },
  {
    id: 2,
    slug: "leasing",
    title: "Leasing",
    shortDescription: "Flexible leasing solutions for all types of vehicles and equipment.",
    image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=400&h=300&fit=crop",
    heroImage: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1200&h=600&fit=crop",
    icon: "FileText",
    features: [
      "100% financing available",
      "Flexible repayment terms up to 6 years",
      "No down payment options",
      "Quick processing within 48 hours",
      "Insurance facilitation",
      "Registration assistance",
      "Competitive rates for all vehicle types",
      "Balloon payment options"
    ],
    eligibility: [
      "Sri Lankan citizens aged 21-55 years",
      "Minimum 2 years employment",
      "Stable monthly income",
      "Guarantor may be required"
    ],
    documents: [
      "NIC copy",
      "Salary confirmation letter",
      "Bank statements (6 months)",
      "Utility bill for address proof",
      "Vehicle quotation"
    ],
    interestRates: [
      { type: "Cars & SUVs", rate: "12% - 15% p.a.", maxTenure: "6 years" },
      { type: "Motorcycles", rate: "14% - 17% p.a.", maxTenure: "5 years" },
      { type: "Commercial Vehicles", rate: "13% - 16% p.a.", maxTenure: "6 years" },
      { type: "Three Wheelers", rate: "15% - 18% p.a.", maxTenure: "5 years" },
      { type: "Machinery & Equipment", rate: "14% - 17% p.a.", maxTenure: "5 years" }
    ]
  },
  {
    id: 3,
    slug: "personal-loan",
    title: "Personal Loan",
    shortDescription: "Quick personal loans for all your financial needs without collateral.",
    image: "/personal-loan-bg.png",
    heroImage: "/personal-loan-bg.png",
    icon: "Wallet",
    features: [
      "Loans up to LKR 5 million",
      "No collateral required",
      "Quick disbursement within 24 hours",
      "Flexible repayment up to 5 years",
      "Minimal documentation",
      "Competitive interest rates",
      "No processing fee promotions",
      "Top-up facility available"
    ],
    eligibility: [
      "Sri Lankan citizens aged 21-55 years",
      "Minimum salary of LKR 30,000",
      "Permanent employment (minimum 1 year)",
      "Good credit score"
    ],
    documents: [
      "NIC copy",
      "Salary slips (3 months)",
      "Bank statements (6 months)",
      "Employment confirmation letter",
      "Utility bill"
    ],
    interestRates: [
      { type: "Up to LKR 500,000", rate: "18% - 20% p.a.", maxTenure: "3 years" },
      { type: "LKR 500,000 - 1 Million", rate: "19% - 21% p.a.", maxTenure: "4 years" },
      { type: "LKR 1 - 3 Million", rate: "20% - 22% p.a.", maxTenure: "5 years" },
      { type: "Above LKR 3 Million", rate: "21% - 24% p.a.", maxTenure: "5 years" }
    ],
    hasCalculator: true,
    loanAmounts: { min: 50000, max: 5000000 },
    tenureMonths: { min: 6, max: 60 }
  },
  {
    id: 4,
    slug: "business-loan",
    title: "Business Loan",
    shortDescription: "Fuel your business growth with our tailored business financing solutions.",
    image: "/business-loan-bg.png",
    heroImage: "/business-loan-bg.png",
    icon: "Building2",
    features: [
      "Loans up to LKR 50 million",
      "Working capital financing",
      "Equipment financing",
      "Business expansion loans",
      "Flexible repayment up to 7 years",
      "Customized repayment schedules",
      "Dedicated relationship manager",
      "Quick approval process"
    ],
    eligibility: [
      "Registered business (minimum 2 years operation)",
      "Profitable business track record",
      "Valid business registration",
      "Audited financial statements",
      "Directors/proprietor as guarantors"
    ],
    documents: [
      "Business registration certificate",
      "Audited financials (2 years)",
      "Bank statements (12 months)",
      "Director/proprietor NIC copies",
      "Business plan (for expansion loans)",
      "Collateral documents (if applicable)"
    ],
    interestRates: [
      { type: "SME Loans (Secured)", rate: "14% - 18% p.a.", maxTenure: "7 years" },
      { type: "SME Loans (Unsecured)", rate: "18% - 22% p.a.", maxTenure: "5 years" },
      { type: "Working Capital", rate: "16% - 20% p.a.", maxTenure: "3 years" },
      { type: "Equipment Financing", rate: "15% - 19% p.a.", maxTenure: "5 years" }
    ],
    hasCalculator: true,
    loanAmounts: { min: 100000, max: 50000000 },
    tenureMonths: { min: 12, max: 84 }
  },
  {
    id: 5,
    slug: "mortgage-loan",
    title: "Mortgage Loan",
    shortDescription: "Unlock the value of your property with our competitive mortgage loans.",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400&h=300&fit=crop",
    heroImage: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop",
    icon: "Home",
    features: [
      "Loans up to 60% of property value",
      "Flexible repayment up to 15 years",
      "Competitive interest rates",
      "Quick property valuation",
      "No prepayment penalties",
      "Use funds for any purpose",
      "Residential & commercial properties",
      "Construction loans available"
    ],
    eligibility: [
      "Property owner (individual or company)",
      "Clear property title",
      "Property in approved location",
      "Stable income source",
      "Sri Lankan citizen or registered company"
    ],
    documents: [
      "Property deed",
      "Survey plan",
      "Building plan approval",
      "Title search report",
      "Income proof",
      "NIC copies of owners",
      "Valuation report"
    ],
    interestRates: [
      { type: "Residential Property", rate: "12% - 15% p.a.", maxTenure: "15 years" },
      { type: "Commercial Property", rate: "14% - 17% p.a.", maxTenure: "12 years" },
      { type: "Land Only", rate: "15% - 18% p.a.", maxTenure: "10 years" },
      { type: "Construction Loan", rate: "14% - 16% p.a.", maxTenure: "20 years" }
    ]
  },
  {
    id: 6,
    slug: "education-loan",
    title: "Education Loan",
    shortDescription: "Invest in your future with our affordable education financing solutions.",
    image: "/education-loan-bg.png",
    heroImage: "/education-loan-bg.png",
    icon: "GraduationCap",
    features: [
      "Finance local & foreign education",
      "Cover tuition, accommodation & expenses",
      "Grace period during studies",
      "Flexible repayment after graduation",
      "Competitive interest rates",
      "No collateral for certain amounts",
      "Quick processing",
      "Covers professional courses"
    ],
    eligibility: [
      "Sri Lankan students",
      "Admission to recognized institution",
      "Parent/guardian as co-applicant",
      "Academic merit consideration"
    ],
    documents: [
      "Admission letter",
      "Fee structure",
      "Student & parent NIC",
      "Academic records",
      "Parent income proof",
      "Guarantor documents"
    ],
    interestRates: [
      { type: "Local Undergraduate", rate: "10% - 13% p.a.", maxTenure: "10 years" },
      { type: "Local Postgraduate", rate: "11% - 14% p.a.", maxTenure: "8 years" },
      { type: "Foreign Studies", rate: "12% - 15% p.a.", maxTenure: "12 years" },
      { type: "Professional Courses", rate: "12% - 15% p.a.", maxTenure: "7 years" }
    ]
  }
];

// All products for the main products page
export const products = [
  ...leasingLoansProducts.map(p => ({ ...p, category: "Leasing & Loans", color: "#2A9D8F" })),
  {
    id: 101,
    slug: "gold-cash",
    title: "Gold Cash",
    category: "Gold Loan",
    shortDescription: "Quick cash against your gold jewelry with competitive interest rates.",
    image: "/gold-cash-bg.png",
    heroImage: "/gold-cash-bg.png",
    hasApplication: true,
    color: "#FFD700",
    features: [
      "Instant cash disbursement",
      "Minimal documentation required",
      "Flexible repayment options",
      "Secure gold storage facilities",
      "Competitive interest rates starting from 12%",
      "Loan tenure up to 12 months"
    ],
    eligibility: [
      "Sri Lankan citizens aged 18 years and above",
      "Valid NIC required",
      "Gold jewelry with minimum 22 karat purity",
      "No income proof required"
    ],
    documents: [
      "Original NIC",
      "Address verification document",
      "Gold jewelry for assessment"
    ],
    interestRates: [
      { type: "Up to 3 months", rate: "12% p.a." },
      { type: "3-6 months", rate: "14% p.a." },
      { type: "6-12 months", rate: "16% p.a." }
    ]
  }
];

export const tenderInfo = [
  {
    id: 1,
    title: "Latest Tender Information",
    image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=400&h=250&fit=crop",
    link: "/tenders"
  },
  {
    id: 2,
    title: "Latest Auction Information",
    image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=400&h=250&fit=crop",
    link: "/auctions"
  },
  {
    id: 3,
    title: "Latest Sales Information",
    image: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400&h=250&fit=crop",
    link: "/sales"
  }
];

export const newsItems = [
  {
    id: 1,
    title: "Pride Path Commercial Strengthens Colombo Presence with the Opening of its 112th Branch in Dematagoda",
    excerpt: "Pride Path Commercial, a leading non-bank financial institution, proudly opened its 112th branch...",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=500&h=350&fit=crop",
    date: "November 15, 2025",
    slug: "112th-branch",
    content: "Pride Path Commercial, a leading non-bank financial institution in Sri Lanka, proudly announced the opening of its 112th branch in Dematagoda, Colombo. This strategic expansion strengthens the company's presence in the capital city and brings our comprehensive financial services closer to customers in this bustling commercial area."
  },
  {
    id: 2,
    title: "Pride Path Commercial Unveils 111th Branch in Eheliyagoda",
    excerpt: "Pride Path Commercial, a leading non-bank financial institution, continues its expansion...",
    image: "https://images.unsplash.com/photo-1541354329998-f4d9a9f9297f?w=500&h=350&fit=crop",
    date: "November 10, 2025",
    slug: "111th-branch",
    content: "Pride Path Commercial continues its nationwide expansion with the opening of its 111th branch in Eheliyagoda."
  },
  {
    id: 3,
    title: "Pride Path Commercial Achieves Historic ICT Triumph with Five Prestigious Wins at National ICT Awards 2025",
    excerpt: "Pride Path Commercial achieved a historic milestone at the National ICT Awards...",
    image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=500&h=350&fit=crop",
    date: "October 28, 2025",
    slug: "ict-awards",
    content: "Pride Path Commercial achieved a historic milestone at the National ICT Awards 2025, winning five prestigious awards."
  },
  {
    id: 4,
    title: "Pride Path Commercial Al-Safa Shines with Six Major Wins at Islamic Finance Forum of South Asia",
    excerpt: "Pride Path Commercial's Islamic Finance Unit, Al-Safa, received prestigious recognition...",
    image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=500&h=350&fit=crop",
    date: "October 20, 2025",
    slug: "islamic-finance-awards",
    content: "Pride Path Commercial's Islamic Finance Unit, Al-Safa, achieved remarkable success at the Islamic Finance Forum of South Asia Awards 2025."
  }
];

export const socialLinks = [
  { platform: "facebook", url: "https://www.facebook.com/share/1AZn5LojD6/", icon: "Facebook", enabled: true },
  { platform: "twitter", url: "", icon: "Twitter", enabled: false },
  { platform: "instagram", url: "", icon: "Instagram", enabled: false },
  { platform: "youtube", url: "", icon: "Youtube", enabled: false },
  { platform: "linkedin", url: "", icon: "Linkedin", enabled: false }
];

export const quickLinks = [
  { label: "About Us", path: "/about" },
  { label: "Our Products", path: "/products" },
  { label: "Contact Us", path: "/contact" },
  { label: "Careers", path: "/about/careers" }
];

export const productCategories = [
  { label: "Leasing & Loans", path: "/products/leasing-loans" },
  { label: "Gold Loan", path: "/products/gold-cash" }
];

// Branch locations data
export const branches = [
  {
    id: 1,
    code: "001",
    name: "Head Office - Buttala",
    address: "11 Mile Post, Monaragala Road, Buttala",
    district: "Monaragala",
    province: "Uva",
    phone: ["+94 55 313 0227", "+94 55 313 0228"],
    fax: "+94 55 313 0229",
    email: "buttala@pridepath.lk",
    services: ["ATM", "CRM", "Gold Loan", "Leasing", "Personal Loan"],
    hours: "Mon - Fri : 8:30 AM - 5:00 PM | Sat : 8:30 AM - 1:00 PM",
    coordinates: { lat: 6.7563, lng: 81.2357 },
    isHeadOffice: true
  },
  {
    id: 2,
    code: "002",
    name: "Colombo Main Branch",
    address: "45/2 Galle Road, Colombo 03",
    district: "Colombo",
    province: "Western",
    phone: ["+94 11 234 5678", "+94 11 234 5679"],
    fax: "+94 11 234 5680",
    email: "colombo@pridepath.lk",
    services: ["ATM", "CRM", "Gold Loan", "Leasing", "Personal Loan", "Business Loan"],
    hours: "Mon - Fri : 8:30 AM - 5:00 PM | Sat : 8:30 AM - 1:00 PM",
    coordinates: { lat: 6.9271, lng: 79.8612 }
  },
  {
    id: 3,
    code: "003",
    name: "Kandy Branch",
    address: "78 Peradeniya Road, Kandy",
    district: "Kandy",
    province: "Central",
    phone: ["+94 81 223 4567"],
    email: "kandy@pridepath.lk",
    services: ["ATM", "CRM", "Gold Loan", "Leasing"],
    hours: "Mon - Fri : 8:30 AM - 5:00 PM | Sat : 8:30 AM - 1:00 PM",
    coordinates: { lat: 7.2906, lng: 80.6337 }
  },
  {
    id: 4,
    code: "004",
    name: "Galle Branch",
    address: "123 Main Street, Galle Fort, Galle",
    district: "Galle",
    province: "Southern",
    phone: ["+94 91 223 4567", "+94 91 223 4568"],
    email: "galle@pridepath.lk",
    services: ["ATM", "CRM", "Gold Loan", "Leasing", "Personal Loan"],
    hours: "Mon - Fri : 8:30 AM - 5:00 PM | Sat : 8:30 AM - 1:00 PM",
    coordinates: { lat: 6.0535, lng: 80.2210 }
  },
  {
    id: 5,
    code: "005",
    name: "Jaffna Branch",
    address: "56 Hospital Road, Jaffna",
    district: "Jaffna",
    province: "Northern",
    phone: ["+94 21 222 3456"],
    email: "jaffna@pridepath.lk",
    services: ["ATM", "CRM", "Gold Loan", "Leasing"],
    hours: "Mon - Fri : 8:30 AM - 5:00 PM | Sat : 8:30 AM - 1:00 PM",
    coordinates: { lat: 9.6615, lng: 80.0255 }
  },
  {
    id: 6,
    code: "006",
    name: "Kurunegala Branch",
    address: "34 Colombo Road, Kurunegala",
    district: "Kurunegala",
    province: "North Western",
    phone: ["+94 37 222 3456", "+94 37 222 3457"],
    email: "kurunegala@pridepath.lk",
    services: ["ATM", "CRM", "Gold Loan", "Leasing", "Personal Loan", "Business Loan"],
    hours: "Mon - Fri : 8:30 AM - 5:00 PM | Sat : 8:30 AM - 1:00 PM",
    coordinates: { lat: 7.4863, lng: 80.3647 }
  },
  {
    id: 7,
    code: "007",
    name: "Ratnapura Branch",
    address: "89 Main Street, Ratnapura",
    district: "Ratnapura",
    province: "Sabaragamuwa",
    phone: ["+94 45 222 3456"],
    email: "ratnapura@pridepath.lk",
    services: ["ATM", "CRM", "Gold Loan", "Leasing"],
    hours: "Mon - Fri : 8:30 AM - 5:00 PM | Sat : 8:30 AM - 1:00 PM",
    coordinates: { lat: 6.6828, lng: 80.3992 }
  },
  {
    id: 8,
    code: "008",
    name: "Anuradhapura Branch",
    address: "23 Main Street, Anuradhapura",
    district: "Anuradhapura",
    province: "North Central",
    phone: ["+94 25 222 3456", "+94 25 222 3457"],
    email: "anuradhapura@pridepath.lk",
    services: ["ATM", "CRM", "Gold Loan", "Leasing", "Personal Loan"],
    hours: "Mon - Fri : 8:30 AM - 5:00 PM | Sat : 8:30 AM - 1:00 PM",
    coordinates: { lat: 8.3114, lng: 80.4037 }
  },
  {
    id: 9,
    code: "009",
    name: "Badulla Branch",
    address: "67 Bank Road, Badulla",
    district: "Badulla",
    province: "Uva",
    phone: ["+94 55 222 3456"],
    email: "badulla@pridepath.lk",
    services: ["ATM", "CRM", "Gold Loan", "Leasing"],
    hours: "Mon - Fri : 8:30 AM - 5:00 PM | Sat : 8:30 AM - 1:00 PM",
    coordinates: { lat: 6.9934, lng: 81.0550 }
  },
  {
    id: 10,
    code: "010",
    name: "Matara Branch",
    address: "45 Beach Road, Matara",
    district: "Matara",
    province: "Southern",
    phone: ["+94 41 222 3456", "+94 41 222 3457"],
    email: "matara@pridepath.lk",
    services: ["ATM", "CRM", "Gold Loan", "Leasing", "Personal Loan"],
    hours: "Mon - Fri : 8:30 AM - 5:00 PM | Sat : 8:30 AM - 1:00 PM",
    coordinates: { lat: 5.9549, lng: 80.5550 }
  },
  {
    id: 11,
    code: "011",
    name: "Negombo Branch",
    address: "234 Lewis Place, Negombo",
    district: "Gampaha",
    province: "Western",
    phone: ["+94 31 222 3456"],
    email: "negombo@pridepath.lk",
    services: ["ATM", "CRM", "Gold Loan", "Leasing"],
    hours: "Mon - Fri : 8:30 AM - 5:00 PM | Sat : 8:30 AM - 1:00 PM",
    coordinates: { lat: 7.2111, lng: 79.8386 }
  },
  {
    id: 12,
    code: "012",
    name: "Trincomalee Branch",
    address: "78 Dockyard Road, Trincomalee",
    district: "Trincomalee",
    province: "Eastern",
    phone: ["+94 26 222 3456"],
    email: "trinco@pridepath.lk",
    services: ["ATM", "CRM", "Gold Loan", "Leasing"],
    hours: "Mon - Fri : 8:30 AM - 5:00 PM | Sat : 8:30 AM - 1:00 PM",
    coordinates: { lat: 8.5874, lng: 81.2152 }
  }
];

// List of all services for filtering
export const branchServices = [
  { id: "atm", label: "ATM", icon: "Wallet" },
  { id: "crm", label: "CRM", icon: "Building2" },
  { id: "gold-loan", label: "Gold Loan", icon: "Coins" },
  { id: "leasing", label: "Leasing", icon: "Car" },
  { id: "personal-loan", label: "Personal Loan", icon: "User" },
  { id: "business-loan", label: "Business Loan", icon: "Briefcase" }
];

// List of all provinces for filtering
export const provinces = [
  "Central",
  "Eastern",
  "North Central",
  "North Western",
  "Northern",
  "Sabaragamuwa",
  "Southern",
  "Uva",
  "Western"
];

export const fleetManagement = {
  name: "Pride Path Fleet Management Limited",
  phone: "0553130227",
  fax: "+94 112 490 160",
  email: "pridepathlk@gmail.com"
};
